import * as React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Box } from "@mui/material";

const InlineText = ({ text, icon, sx, ...rest }) => {
    return (
        <Box sx={{ display: "flex", alignItems: "start", justifyContent: "start", ...sx }}>
            <Box sx={{ marginRight: "10px", marginTop: "-1.8px" }}>{icon}</Box>
            <Box>{text}</Box>
        </Box>
    );
};

export { InlineText };
